import gql from 'graphql-tag';

export const GetUserAccessQuery = gql`
	query GetUserAccessQuery($resourceId: String!, $permissionId: String!) {
		confluence_tenantContext {
			licensedProducts {
				licenseStatus
				productKey
			}
		}
		permitted(resourceId: $resourceId, permissionId: $permissionId)
	}
`;
